<template lang="pug">

  div

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    turn-value-editor-modal(ref="modalShiftValueEditor" @changed="onShiftValueChange")

    //-
      -
      - EDITOR DE TURNOS
      -
      -

    v-dialog(v-model="show" max-width="730px" :persistent="loading === true").shiftsModalCustomHeight

      .dialogHeader

        .dialogHeaderTitle
          | Meus Turnos

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close()")

      .dialogBody

        .dialogBodyContent(v-if="loading" :style="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }")
          v-progress-circular(indeterminate color="red")

        .dialogBodyContent(v-else)

          div(v-if="shifts.length === 0" class="pt-6")
            | Você não possui turnos.

          table(v-else cellspacing="0" cellpadding="0").shiftsList
            thead
              tr
                th(style="width: 46px")
                  span
                    | &nbsp;
                th(style="width: 75px")
                  span INÍCIO
                th(style="width: 90px")
                  span DURAÇÃO
                th(style="width: 100px")
                  span TÉRMINO
                th(style="width: 135px")
                  span VALOR
                th(style="width: 150px")
                  span DIAS DA SEMANA
                th(width="0px")
                  span NOME
            tbody

              tr(v-for="shiftItem in shifts" :key="shiftItem.id")

                td(data-label="APAGAR")
                  sos-button(
                    @buttonClick="removeTurn(shiftItem.id)"
                    title="Apagar turno"
                    buttonLabel=""
                    buttonIcon="mdi-delete"
                    buttonIconSize="14"
                    size="small"
                    color="default"
                    :disabled="shifts.length <= 1"
                    :rounded="true"
                  ).px-1.mr-0

                td(data-label="INÍCIO")
                  | {{ shiftItem.hour }}

                td(data-label="DURAÇÃO")
                  | {{ shiftItem.duration }}

                td(data-label="TÉRMINO")
                  | {{ shiftItem.endTime }}

                td(data-label="VALOR")
                  sos-button(
                    @buttonClick="openShiftValueEditor(shiftItem.id, shiftItem.value)"
                    title="Editar"
                    buttonLabel=""
                    buttonIcon="mdi-pencil"
                    buttonIconSize="14"
                    size="small"
                    color="success"
                    :disabled="shifts.length <= 1"
                    :rounded="true"
                  ).px-1.mr-2

                  | {{ shiftItem.formattedValue }}

                td(v-if="shiftItem.days.length === 7" data-label="DIAS DA SEMANA")
                  span(class="days")
                    | TODOS OS DIAS
                td(v-else data-label="DIAS DA SEMANA")
                  span(v-for="d in shiftItem.days" :key="d" class="days")
                    | {{ getTurnDayName(d) }}

                td(data-label="NOME")
                  input(
                    :disabled="shiftItem.saving"
                    type="text"
                    v-model="shiftItem.name_editable"
                    @blur="onShiftNameBlur(shiftItem.id)"
                    maxlength="56"
                    placeholder="Nome"
                  ).sosInput

          sos-button(
            v-if="!showNewTurnForm"
            @buttonClick="showNewTurnForm = true"
            buttonLabel="Criar turno"
            buttonIcon="mdi-plus"
            buttonIconSize="20"
            size="medium"
            color="success"
            :loading="loading || creatingTurn"
          ).mt-6

          div(v-if="showNewTurnForm").newShiftForm

            .createTurnTitle
              | Informe os detalhes do novo turno

            .createTurnField
              label.csLabel
                span(v-html="'Horário de início <span class=\"vLabelDescription\">(Entre 00:00 e 23:59)</span>'")
              .sosFieldGroup
                .sosField.sosFieldColumn--1
                  sos-select(label="" :default="selectedHour" @sosSelectChanged="onSelectStartHour" :items="allowedStartHours")
                span.csHourMinuteDivisor
                  | :
                .sosField.sosFieldColumn--2
                  input(type="text" v-model="digitedStartMinute" maxlength="2" placeholder="00" @input="onDigitedStartMinute" @blur="onDigitedStartMinuteBlur" pattern="\d{2}").sosInput
              .sosFieldGroupError(v-if="selectedHour === ''")
               | Informe o horário de início.

            .createTurnField
              label.csLabel
                span(v-html="'Duração <span class=\"vLabelDescription\">(Entre 30 minutos e 24 horas)</span>'")
              .sosFieldGroup
                .sosField.sosFieldColumn--1
                  sos-select(label="" :default="selectedDurationHour" @sosSelectChanged="onSelectDurationHour" :items="allowedDurationHours")
                span.csHourMinuteDivisor
                  | :
                .sosField.sosFieldColumn--2
                  input(type="text" v-model="digitedDurationMinute" maxlength="2" placeholder="00" @input="onDigitedDurationMinute" @blur="onDigitedDurationMinuteBlur" pattern="\d{2}" :disabled="this.selectedDurationHour === '24'").sosInput

              .sosFieldGroupError(v-if="selectedDurationHour === ''")
                | Informe a duração.

            .createTurnField
              label.csLabel
                span(v-html="'Valor <span class=\"vLabelDescription\">(Opcional)</span>'")
              .csFields
                app-money-light(:value="selectedValue" :blur-event="changeMoneyValueBlurEvent")

            .createTurnField
              label.csLabel
                span(v-html="'Nome <span class=\"vLabelDescription\">(Opcional)</span>'")
              .csFields
                input(type="text" v-model="turnName" maxlength="56").sosInput

            .createTurnField.createTurnField--last
              label.csLabel
                span Selecione os dias da semana
              .diasDaSemana
                sos-button(
                  v-for="weekDay in selectedDays"
                  :key="`weekDay_${weekDay.day}`"
                  @buttonClick="selectWeekDay(weekDay)"
                  :buttonLabel="weekDay.dayName"
                  :buttonIcon="weekDay.dayStatus ? 'mdi-check' : ''"
                  buttonIconSize="14"
                  size="small"
                  :color="weekDay.dayStatus ? 'success' : 'lightgrey'"
                  :disabled="creatingTurn"
                ).ma-1
              .sosFieldGroupError(v-if="selectedDaysOnly.length === 0")
                | Marque pelo menos um dia da semana.

            .mt-6
              sos-button(
                @buttonClick="createShift()"
                buttonLabel="Criar turno"
                buttonIcon="mdi-plus"
                buttonIconSize="20"
                size="medium"
                color="success"
                :loading="creatingTurn"
                :disabled="!isValid")

</template>

<script>

  import { apiUpdateScaleTurn } from '@/services/endpoints/scales'
  import { apiCreateShift, apiDeleteScaleTurn, apiGetUserId } from '@/services/firebase'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import { formatMoney, timeToFloat, formatDuration, calculateEndTime } from '@/mixins/utils'
  import { valueToTime } from '@/functions'

  import AppMoneyLight from '@/components/base/AppMoneyLight'
  import SosButton from '@/components/SosButton'
  import SosSelect from '@/components/SosSelect'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import TurnValueEditorModal from './TurnValueEditorModal'

  //
  //
  //

 /**
  * Gera uma lista de objetos com minutos formatados, utilizados em selects.
  *
  * @param {Object} options
  * @param {number} [options.start=0] - Minuto inicial (ex: 0).
  * @param {number} [options.length=60] - Total de minutos a considerar (ex: 60).
  * @param {string} [options.prefix='unknown'] - Prefixo para a chave `key`.
  * @param {number} [options.step=1] - Passo entre cada minuto (ex: 5 para pular de 5 em 5 minutos).
  * @returns {Array<{ key: string, text: string, value: string }>}
  */
  function buildTimes({ start = 0, length = 60, prefix = 'unknown', step = 1 }) {
    const result = []
    for (let i = start; i < start + length; i += step) {
      const minute = i.toString().padStart(2, '0')
      result.push({
        key: `${prefix}_${minute}`,
        text: minute,
        value: minute,
      })
    }
    return result
  }

  const allowedStartHours = buildTimes({ prefix: 'sh', length: 24 });
  const allowedStartMinutes = buildTimes({ prefix: 'sm', length: 60, step: 5 });
  const allowedDurationHours = buildTimes({ prefix: 'dh', length: 25 });
  const allowedDurationMinutes = buildTimes({ prefix: 'dm', length: 60, step: 10 });
  const allowedDurationMinutesMidnight = buildTimes({ prefix: 'dm', start: 30, length: 30, step: 10 });

  const selectedDays = [
    { day: 0, dayName: 'DOM', dayStatus: true },
    { day: 1, dayName: 'SEG', dayStatus: true },
    { day: 2, dayName: 'TER', dayStatus: true },
    { day: 3, dayName: 'QUA', dayStatus: true },
    { day: 4, dayName: 'QUI', dayStatus: true },
    { day: 5, dayName: 'SEX', dayStatus: true },
    { day: 6, dayName: 'SAB', dayStatus: true },
  ]

  //
  //
  //

  export default {
    name: 'TurnsModal',

    components: {
      'app-money-light': AppMoneyLight,
      'sos-button': SosButton,
      'sos-select': SosSelect,
      'confirm-dialog': ConfirmDialog,
      'turn-value-editor-modal': TurnValueEditorModal,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        show: false,

        loading: false,
        creatingTurn: false,

        // "NEW SHIFT" FORM STATUS
        showNewTurnForm: false,

        // OPEN PARAMETERS/ARGUMENTS
        mes: null,
        ano: null,
        groupID: '',
        scaleID: '',
        shifts: [], // JESUS: Parou de escutar em tempo real

        // SELECT OPTIONS
        allowedStartHours,
        allowedStartMinutes,
        allowedDurationHours,
        allowedDurationMinutes,
        selectedDays,

        // NEW SHIFT

        digitedDurationMinute: '',
        digitedStartMinute: '',
        selectedHour: '',
        selectedDurationHour: '',
        selectedValue: 0, // 'R$ 0,00',
        turnName: '',
      }
    },

    computed: {
      selectedDaysOnly: function () {
        return this.selectedDays.filter(d => !!d.dayStatus).map(d => d.day)
      },

      isValid: function () {
        const selectedDays = this.selectedDays.filter(d => !!d.dayStatus)

        return (
          this.selectedHour !== '' &&
          this.selectedDurationHour !== '' &&
          selectedDays.length > 0
        )
      },
    },

    watch: {
      show: {
        immediate: true,
        handler: function (newShow, oldShow) {
          if (newShow !== true) {
            this.showNewTurnForm = false
          }

          const closing = oldShow === true && newShow === false

          if (closing) {
            // console.log('[TurnsModal] closing')
            this.show = false
            this.showNewTurnForm = false
            this.closeShiftValueEditor()
            // this.$emit('close', false)
          }
        },
      },

      //
      // 00 [30, 40 e 50]
      // 01 - 23 [00, 10, 20, 30, 40 e 50]
      // 24 [00]
      //

      selectedDurationHour: {
        immediate: true,
        handler: function (newHour, oldHour)
        {
          if (newHour !== oldHour)
          {
            // [
            //   { key: 'dm_30', text: '30', value: '30' },
            //   { key: 'dm_40', text: '40', value: '40' },
            //   { key: 'dm_50', text: '50', value: '50' },
            // ]

            //
            const allowedDurationMinutesCurrent = newHour === '00' ? allowedDurationMinutesMidnight : (
              newHour === '24' ? [
                { key: 'dm_00', text: '00', value: '00' },
              ] : allowedDurationMinutes
            )
            this.allowedDurationMinutes = allowedDurationMinutesCurrent

            //
            if (!allowedDurationMinutesCurrent.some(dm => dm.value === this.digitedDurationMinute)) this.digitedDurationMinute = ''
          }
        },
      },
    },

    /* mounted () {
      // console.log('TurnsModal[turns]:', this.shifts)
    }, */

    methods: {
      //
      // OPEN
      //

      open (args)
      {
        this.mes = args.mes
        this.ano = args.ano
        this.groupID = args.groupID
        this.scaleID = args.scaleID

        this.buildShiftsList(args.turns)

        this.show = true
      },

      //
      //
      //

      close ()
      {
        if (this.loading === true || this.creatingTurn === true) return false
        this.show = false
      },

      //
      //
      //

      getTurnDayName: function (dayId) {
        const foundDayByDayId = this.selectedDays.find(sd => sd.day === dayId)
        return foundDayByDayId ? foundDayByDayId.dayName : '-'
      },

      buildShiftsList (shifts) {
        this.shifts = shifts.length > 0 ? shifts.map(turn => {
          const turnDuration = valueToTime(turn.duration);
          const durationFormatted = turn.duration === 24 || turn.duration === '24' || turn.duration === '24:00'
            ? '24h'
            : formatDuration(turnDuration, true);

          return {
            ...turn,
            id: turn.turnID,
            name: String(turn.name || '').trim(),
            name_editable: String(turn.name || '').trim(),
            hour: valueToTime(turn.hour),
            duration: durationFormatted,
            decimalHour: timeToFloat(turn.hour),
            formattedValue: formatMoney(turn.value || 0),
            endTime: calculateEndTime(valueToTime(turn.hour), turnDuration),
          };
        }) : []

        this.shifts.sort((a, b) => (a.decimalHour - b.decimalHour))
      },

      addShiftToList (shift) {
        const newShift = {
          ...shift,
          //endTime: calculateEndTime(shift.hour, shift.duration)
        }
        this.shifts = [...this.shifts, newShift]
        this.shifts.sort((a, b) => (a.decimalHour - b.decimalHour))
      },

      //
      // HANDLE NEW SHIFT FIELDS
      //

      onDigitedStartMinute ({ target }) {
        let value = target.value.replace(/\D/g, '') // remove não-dígitos
        if (value.length > 2) value = value.slice(0, 2)    // força dois dígitos no máximo

        const numeric = parseInt(value, 10)

        if (!isNaN(numeric) && numeric > 59) {
          value = '59'
        }

        this.digitedStartMinute = value
      },

      onDigitedStartMinuteBlur({ target }) {
        const value = target.value;
        this.digitedStartMinute = value.padStart(2, '0')
      },

      onDigitedDurationMinute({ target }) {
        const value = target.value;

        if (this.selectedDurationHour === '24') return this.digitedDurationMinute = '00';

        this.digitedDurationMinute = value
      },

      onDigitedDurationMinuteBlur({ target }) {
        const value = target.value;
        this.digitedDurationMinute = value.padStart(2, '0')
      },

      onSelectStartHour (hour) {
        this.selectedHour = hour
      },

      onSelectDurationHour (hour) {
        this.selectedDurationHour = hour
      },

      // onSelectDurationMinute (min) {
      //   this.selectedDurationMinute = min
      // },

      // VALUE
      changeMoneyValueBlurEvent (moneyValue) {
        this.selectedValue = moneyValue
      },

      // WEEK DAYS
      selectWeekDay (weekDay) {
        let days = this.selectedDays.filter(d => d.day !== weekDay.day)
        const day = weekDay

        day.dayStatus = !day.dayStatus

        days = [...days, day]
        days.sort((a, b) => (a.day - b.day))

        return days
      },

      // TURN NAME
      async onShiftNameBlur(turnID)
      {
        let turn = this.shifts.find(t => t.id === turnID)
        if (!turn) return false

        const newName = String(turn.name_editable || '').trim()
        const currentName = String(turn.name || '').trim()
        if (newName === currentName) return false

        // Disable
        turn.saving = true
        this.shifts = [...this.shifts]

        // Request
        const request = await apiUpdateScaleTurn(apiGetUserId(), this.groupID, this.scaleID, turnID, { name: newName })

        // Enable
        turn = this.shifts.find(t => t.id === turnID)
        // if (!turn) return false
        turn.saving = false
        this.shifts = [...this.shifts]

        // Response
        if (request.httpCode !== 200) {
          turn.name_editable = currentName
          this.showMessage(request.title, request.message)
        } else {
          turn.name = newName
        }
      },

      //
      // CRIAR TURNO
      //

      async createShift ()
      {
        if (this.loading === true || this.creatingTurn === true) return false

        if (this.selectedDurationHour === '00' && this.digitedDurationMinute < '30') return this.showMessage('Atenção!', 'A duração precisa ter no mínimo 30 minutos, revise o compo por gentileza.')

        // Atribui zero se estiver vázio (Placeholder informa que o valor está preenchido por padrão)
        this.digitedStartMinute = this.digitedStartMinute === '' ? '00' : this.digitedStartMinute;
        this.digitedDurationMinute = this.digitedDurationMinute === '' ? '00' : this.digitedDurationMinute;

        const startTime = `${this.selectedHour}:${this.digitedStartMinute}`
        const duration = `${this.selectedDurationHour}:${this.digitedDurationMinute}`
        const value = this.selectedValue
        const name = String(this.turnName || '').trim()
        const days = [...this.selectedDaysOnly].sort((a, b) => a - b)

        this.creatingTurn = true
        const request = await apiCreateShift(this.groupID, this.scaleID, days, startTime, duration, value, name)
        this.creatingTurn = false

        if (request.code === 1) {
          const durationFormatted = duration === '24:00' ? '24h' : formatDuration(valueToTime(duration), true);

          this.addShiftToList({
            // ...shift,
            grupo: this.groupID,
            escala: this.scaleID,
            days,
            hour: valueToTime(startTime),
            duration: durationFormatted,
            value: value || 0, // JESUS: Correto?
            name,
            // ...shift,

            id: request.message,
            name_editable: name,
            decimalHour: timeToFloat(startTime),
            formattedValue: formatMoney(value || 0),
            endTime: calculateEndTime(valueToTime(startTime), valueToTime(duration)),
          })
        }

        this.showMessage(request.title, request.code === 0 ? request.message : 'O turno foi criado!')
      },

      //
      // HANDLE SHIFT VALUE EDITOR MODAL
      //

      openShiftValueEditor: function (shiftID, shiftValue) {
        if (this.loading === true || this.creatingTurn === true) return false

        this.$refs.modalShiftValueEditor.open({
          mes: this.mes,
          ano: this.ano,
          groupID: this.groupID,
          scaleID: this.scaleID,
          shifts: this.shifts,
          shiftID,
          shiftValue,
        })
      },

      closeShiftValueEditor: function () {
        // if (this.loading === true || this.creatingTurn === true) return false
        this.$refs.modalShiftValueEditor.close()
      },

      // Alterando valor do turno SEM REALTIME
      onShiftValueChange (response)
      {
        const turn = this.shifts.find(t => t.id === response.id)
        if (!turn) return false

        turn.value = response.newValue || 0
        turn.formattedValue = formatMoney(response.newValue || 0)
      },

      //
      // HANDLE SHIFT DELETION
      //

      // ASK WHETHER THE USER CONFIRM THE SHIFT DELETION OR NOT
      removeTurn (turnID) {
        if (this.loading === true || this.creatingTurn === true) return false

        this.showDialog('Atenção!', 'O turno será apagado. <b>Deseja continuar?</b>', 'delete-shift', turnID)
      },

      // DELETE THE SHIFT
      cdAction (cdResponse)
      {
        // console.log('::: TURNS MODAL -> cdAction:', cdResponse)

        if (cdResponse === false) return false

        //
        // DELETE SHIFT PROCEDURE
        //

        if (cdResponse.cdType === 'delete-shift')
        {
          const turnID = cdResponse.cdData

          this.loading = true

          //
          // JESUS: Apagar plantões do turno
          //

          apiDeleteScaleTurn(this.groupID, this.scaleID, turnID, response => {
            this.loading = false

            // Removendo da lista de turnos SEM REALTIME
            if (response.code !== 0) {
              this.shifts = this.shifts.filter(t => t.id !== turnID)
            }

            this.showMessage(response.code === 0 ? 'Erro' : 'Sucesso', response.message)
          })
        }
      },
    },
  }

</script>

<style scoped lang="scss">

  .shiftsModalCustomHeight {
    max-height: 400px;
  }

  .sosField {
    position: relative;

    margin-top: 15px;
    margin-bottom: 15px;

    &.sosField--first {
      margin-top: 0;
    }

    &.sosField--last {
      margin-bottom: 0;
    }
  }

  .sosFieldGroupError {
    display: inline-block;
    margin-top: 12px;

    color: #ff4500;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
  }

  .sosFieldGroup {
    position: relative;

    margin: -5px;

    .sosField {
      display: inline-block;
      vertical-align: middle;
      padding: 5px;
      margin-top: 0;
      margin-bottom: 0;

      &.sosFieldColumn--1,
      &.sosFieldColumn--2,
      &.sosFieldColumn--3 {
        width: 100%;
        max-width: 150px;
      }
    }
  }

  //
  //
  //

  .diasDaSemana {
    margin: -4px;
  }

  .createTurnTitle {
    position: absolute;
    top: -12px;
    left: 14px;
    display: inline-block;
    padding: 4px 10px;
    background-color: #FFFFFF;
    font-size: 16.5px;
    line-height: 16.5px;
    font-weight: 600;
  }

  .newShiftForm {
    position: relative;
    margin-top: 45px;
    border: 1px solid rgba(0,0,0,0.3);
    border-radius: 7px;
    // padding: 28px 25px 20px 25px;
    padding: 10px 25px 20px 25px;

    font-size: 0;
  }

  .csHourMinuteDivisor {
    display: inline-block;
    vertical-align: middle;
    padding: 0 5px;
    font-size: 16px;
  }

  /*  */

  .shiftsList th {
    padding: 10px 7px;
  }

  .shiftsList td {
    padding: 5px 7px;
  }

  .shiftsList .days {
    padding: 3px 5px;
    border: 1px solid #AAAAAA;
    border-radius: 7px;
    /* display: block; */
    display: inline-block;
    background-color: #696969;
    margin-top: 1.5px;
    margin-right: 2px;
    margin-bottom: 1.5px;
    margin-left: 0;
    color: #FFF;
    font-size: 12px;
    line-height: 12px;
    font-weight: 500;
  }

  //
  //
  //

  [data-label="VALOR"] {
    text-align: left !important;
    white-space: nowrap;
  }

  [data-label="NOME"] input {
    width: 100%;
    // max-width: 100px;
    height: 40px;
    padding: 0 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #FFFFFF;
  }

  .shiftsList {
    font-size: 14px;
    border: 1px solid #ccc;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    width: 100%;
    // margin-top: 24px;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: 0;
    margin-right: 0;
    // table-layout: fixed;
  }

  .shiftsList caption {
    font-size: 1.5em;
    margin: .5em 0 .75em;
  }

  .shiftsList tr {
    background-color: #f8f8f8;
    border: 1px solid #ddd;
    padding: .35em;
  }

  .shiftsList th,
  .shiftsList td {
    padding: .625em;
    text-align: center;
  }

  .shiftsList th {
    font-size: .85em;
    letter-spacing: .1em;
    text-transform: uppercase;
  }

  @media (max-width: 768px)
  {
    [data-label="VALOR"] {
      text-align: right !important;
    }

    .shiftsList {
      border: 0;
    }

    .shiftsList caption {
      font-size: 1.3em;
    }

    .shiftsList thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    .shiftsList tr {
      border-bottom: 3px solid #ddd;
      display: block;
      margin-bottom: .625em;
    }

    .shiftsList td {
      border-bottom: 1px solid #ddd;
      display: block;
      // font-size: .8em;
      font-size: 1em;
      text-align: right;

      padding: 0px 7px !important;
      line-height: 38px;
    }

    .shiftsList td::before {
      /*
      * aria-label has no advantage, it won't be read inside a table
      content: attr(aria-label);
      */
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
    }

    .shiftsList td:last-child {
      border-bottom: 0;
    }
  }

</style>
